import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFileGreenCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
			fill: "#D8F4E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2 15.9521V44.3942C19.2 44.6368 19.2962 44.8695 19.4673 45.0413C19.6385 45.2132 19.8709 45.3103 20.1134 45.3113H42.0201C42.2633 45.3113 42.4966 45.2147 42.6686 45.0427C42.8406 44.8707 42.9372 44.6374 42.9372 44.3942V22.6068H36.2825C36.1607 22.6068 36.0402 22.5826 35.928 22.5356C35.8157 22.4886 35.714 22.4197 35.6286 22.3329C35.5432 22.2462 35.476 22.1433 35.4308 22.0303C35.3856 21.9173 35.3633 21.7965 35.3653 21.6748V15.0349H20.1134C19.8709 15.0359 19.6385 15.133 19.4673 15.3049C19.2962 15.4767 19.2 15.7095 19.2 15.9521Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.1066 15.8468C20.0815 15.8468 20.0574 15.8568 20.0397 15.8746C20.0219 15.8923 20.0119 15.9164 20.0119 15.9415V44.406C20.0119 44.4311 20.0219 44.4552 20.0397 44.473C20.0574 44.4908 20.0815 44.5007 20.1066 44.5007H42.0319C42.057 44.5007 42.0809 44.4909 42.0986 44.4734C42.1156 44.4566 42.1257 44.4338 42.1266 44.4096V22.9435L35.03 15.8468H20.1066ZM18.8924 14.7273C19.2145 14.4053 19.6512 14.2244 20.1066 14.2244H35.366C35.5811 14.2244 35.7875 14.3098 35.9396 14.462L43.5115 22.0339C43.6636 22.186 43.7491 22.3923 43.7491 22.6075V44.4272C43.7435 44.8789 43.5602 45.3103 43.2386 45.6278C42.9171 45.9453 42.4836 46.1232 42.0319 46.1232H20.1066C19.6512 46.1232 19.2145 45.9423 18.8924 45.6202C18.5705 45.2982 18.3895 44.8615 18.3895 44.406V15.9415C18.3895 15.4861 18.5704 15.0494 18.8924 14.7273Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3653 15.0349L35.3646 21.6971C35.3656 21.9411 35.4629 22.1747 35.6354 22.3472C35.8079 22.5197 36.0415 22.617 36.2855 22.618H42.9365L35.3653 15.0349Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.0551 14.286C35.3584 14.1605 35.7077 14.2297 35.9396 14.462L43.5112 22.0455C43.743 22.2776 43.8121 22.6264 43.6865 22.9294C43.5609 23.2324 43.2652 23.4299 42.9372 23.4299H36.2829C35.8249 23.4281 35.3863 23.2453 35.0625 22.9215M35.0625 22.9215C34.7387 22.5977 34.5559 22.1591 34.5541 21.7012L34.5541 21.6978V15.0356C34.5541 14.7074 34.7518 14.4115 35.0551 14.286M36.1765 16.9961V21.6954C36.1768 21.725 36.1888 21.7533 36.2097 21.7743C36.2306 21.7952 36.259 21.8071 36.2885 21.8075H40.9807L36.1765 16.9961Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.515 26.0183C24.515 25.5702 24.8782 25.207 25.3262 25.207H36.8127C37.2607 25.207 37.6239 25.5702 37.6239 26.0183C37.6239 26.4663 37.2607 26.8295 36.8127 26.8295H25.3262C24.8782 26.8295 24.515 26.4663 24.515 26.0183Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.515 29.3972C24.515 28.9491 24.8782 28.5859 25.3262 28.5859H36.8127C37.2607 28.5859 37.6239 28.9491 37.6239 29.3972C37.6239 29.8452 37.2607 30.2084 36.8127 30.2084H25.3262C24.8782 30.2084 24.515 29.8452 24.515 29.3972Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.515 32.77C24.515 32.322 24.8782 31.9588 25.3262 31.9588H36.8127C37.2607 31.9588 37.6239 32.322 37.6239 32.77C37.6239 33.218 37.2607 33.5812 36.8127 33.5812H25.3262C24.8782 33.5812 24.515 33.218 24.515 32.77Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.515 36.1489C24.515 35.7009 24.8782 35.3377 25.3262 35.3377H33.983C34.431 35.3377 34.7942 35.7009 34.7942 36.1489C34.7942 36.5969 34.431 36.9601 33.983 36.9601H25.3262C24.8782 36.9601 24.515 36.5969 24.515 36.1489Z",
			fill: "#03A65B"
		})
	]
});
const ForwardRef = forwardRef(SvgIcFileGreenCircle);
export default ForwardRef;
